import React from 'react';
import {USER_TYPE_REP, USER_TYPE_RETAILER} from '../../data/userTypes';
import {dateFormatUK} from '../../utils/commonFunctions';

const PersonalDetails = ({profile, type = USER_TYPE_RETAILER}) => (
  <div>
    <h4 className="my-profile-details-personal-heading">Personal Details</h4>

    <div className="my-profile-details-personal-title">{profile.title}</div>
    <div className="my-profile-details-personal-name">{profile['first-name']}{' '}{profile['last-name']}</div>
    <div className="my-profile-details-personal-text">{type === USER_TYPE_REP && profile.email}</div>
    <div className="my-profile-details-personal-text">{'Date of birth: '}{dateFormatUK(profile['date-of-birth'])}</div>
  </div>
);

export default PersonalDetails;



// WEBPACK FOOTER //
// ./src/components/my-profile/personal-details.jsx